import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_CHART_SUCCESS,
  UPDATE_DATES,
  UPDATE_CUSTOM_RANGE,
  UPDATE_TABLE_VIEW_SELECTED,
  SET_DATES,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_UPDATES_LOADING,
  RESET_FILTER_SELECTED
} from "./averageNumberOfClientsPerClassSagas";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../../utils/date-range-options";

export const initialState = {
  currentUser: {},
  initialRequest: false,
  chartData: {},
  isLoading: true,
  updatesLoading: false,
  filtersDirty: false,
  datesDirty: false,
  selectedRequestDates: {},
  filters: {
    include_returns: false,
    net_revenue_toggle_name: "Net Revenue",
    show_expenses: false
  },
  selectedFilters: {
    table_view: false
  },
  selectedRangeOption: {},
  rangeOptions: []
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => {
      let rangeOptions = getRangeOptions(
        state.currentUser.calendarEndDate,
        state.currentUser.calendarStartDate
      );

      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: [...rangeOptions, getSelectedRangeOptionWithCustom(action)],
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true,
      datesDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload,
      filtersDirty: true,
      datesDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action)
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      datesDirty: false,
      selectedFilters: { ...initialState.selectedFilters }
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    })
  },
  initialState
);
